<!-- 校审流程展示的文件列表 -->
<template>
  <div>
    <el-table v-if="flowFileList.length > 0" :data="flowFileList" :show-header="false" max-height="200px">
      <el-table-column label="名称" prop="name">
        <template slot-scope="scope">
          <div class="nameStyle">
            <fileLightFlag v-if="routerParams.flowStatus&&routerParams.status" :row="scope.row" :form-flow="true"
              @updateLight="updateLight" />
            <div class="fileNameStyle">
              <img v-if="scope.row.isFolder != 1" :src="className(scope.row)" class="img" alt="" />
              <img v-else :src="icon" class="img" alt="" />
              <span v-if="scope.row.isRead === 1" style="cursor: pointer;color: var(--theme-color)"
                @click="preview(scope.row)">{{ scope.row.fileName }}</span>
              <span v-else-if="scope.row.isRead === 0 " style="cursor: pointer;"
                @click="preview(scope.row)">{{ scope.row.fileName }}</span>
              <span v-else style="cursor: pointer;" @click="preview(scope.row)">{{ scope.row.fileName }}</span>

              <span style="margin-left: 50px">{{ scope.row.pathName }}</span>
              <el-link v-if="scope.row.pathName && (showBar||isRVT)" type="primary" style="margin-left: 15px"
                @click.native="toProjectDoc(scope.row.paths)">
                跳转
              </el-link>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- 校审流程最后一个绑定节点显示绑定状态、绑定按钮 -->
      <el-table-column label="绑定" prop="bindStatus" style="float:left">
        <template slot-scope="scope">
          <div v-if="scope.row.bindStatus == 0" class="table_class approval_class"> 未绑定 </div>
          <div v-else-if="scope.row.bindStatus == 1" class="table_class adopt_class"> 绑定成功 </div>
          <div v-else class="table_class reject_class"> 绑定失败 </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120px">
        <template slot-scope="scope">
          <span class="midd-table">
            <!-- 校审流程显示校审按钮，功能同预览 -->
            <img :src="proofread_png" alt="校审" class="midd-img" title="校审" @click="preview(scope.row)" />
            <!-- 校审流程最后一个绑定节点显示绑定按钮 -->
            <img v-if="flowStageName=='绑定'&&scope.row.bindStatus == 0" :src="binding_png" alt="绑定" title="绑定"
              class="midd-img" @click="binding(scope.row)" />
            <img v-if="flowStageName=='绑定'&&scope.row.bindStatus !== 0" :src="binding_png" alt="重新绑定" title="重新绑定"
              class="midd-img" @click="binding(scope.row)" />
            <i class="el-icon-download" title="下载" style="margin-right: 15px; color: var(--theme-color)"
              @click="downLoadFile(scope.row)" />
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { tableRowIcon, noLabelFilePreview, windowOpen, common2D3DFileType } from "@/CommonDP/utils/docPublic";
import flowService from "@/CommonDP/service/flow-service";
import xtDesign from "@/CommonDP/service/integratedModel-service";
import { downloadFile, flowFileDownLoad } from "@/CommonDP/utils";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import docService from "@/CommonDP/service/doc-service";
import XtDesignService from "@/CommonDP/service/XtDesign-service";

export default {
  components: { fileLightFlag },
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      flowFileList: [],
      flowStageName: "",
      proofread_png: require("@/CommonDP/assets/approval/proofread.png"),
      binding_png: require("@/CommonDP/assets/approval/binding.png")
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    // cad跳转样式
    showBar() {
      if (window.location.href.indexOf("jsName=BimEx") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    // rvt跳转样式
    isRVT() {
      if (window.location.href.indexOf("jsName=BimExRVT") !== -1) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    async files(newValue) {
      await this.setFilePath(newValue);
    }
  },

  methods: {
    refresh() {
      const noSuccessfileList = this.flowFileList.filter((item) => (item.status != 2 && item.status != 6) &&
      common2D3DFileType(item));
      noSuccessfileList.forEach(async ele => {
        const { data } = await XtDesignService.getFileDetails(ele.fileId);
        this.$set(ele, 'status', data.status);
      });
    },
    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.fileId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    // 设置文件路径
    async setFilePath(val) {
      if (val.length) {
        for (const a in val) {
          val[a].paths = [];
          val[a].pathName = "";
          if (val[a].uploadType !== 1) {
            const res = await flowService.getAssociatedFileLocation(val[a].fileId);
            const location = res.data || [];
            if (location.length) {
              val[a].paths = location;
              for (const i in location) {
                val[a].pathName = val[a].pathName + location[i].folderName + "/";
              }
              if (val[a].pathName) {
                val[a].pathName = val[a].pathName.substring(0, val[a].pathName.length - 1);
              }
            }
          }
        }
        this.flowFileList = val;
      }
    },

    // 跳转到项目文件，打开文件所在文件夹
    async toProjectDoc(paths) {
      const prjId = this.routerParams.prjId || this.prjInfo?.prjId;
      const result = await flowService.getProjectUsers(prjId);
      const users = result.data || [];
      const exist = users.filter(item => item.userId == this.userInfo.userId);
      if (!exist || !exist.length) {
        this.$message.warning("当前用户不在该项目内");
        return;
      }
      const res = await flowService.viewList(prjId);
      this.$store.dispatch("updatePrj", res.data);
      this.$store.dispatch("XtDesignUpdateNav", paths);
      this.$router.push({
        path: "/project-XtDesign"
      });
    },
    // 文件预览打开,文件变色
    async preview(row) {
      const params = {
        flowBusinessId: this.routerParams.flowBusinessId,
        fileId: row.fileId,
        fileName: row.fileName
      };
      const res = await flowService.readFlowFile(params);
      if (res.result === "0") row.isRead = 1;
      this.onLineView(row);
    },

    async onLineView(row) {
      const value = {
        folderId: row.fileId,
        folderName: row.fileName,
        parentId: row.parentId,
        fileVersion: row.versionIds || 1,
        fileType: Number(row.fileType),
        status: row.status
      };
      if (value.status === 2) {
        value.status = value.status.toString();
      }
      const prjId = this.routerParams.prjId || this.prjInfo.prjId;
      // 获取当前项目的名称
      const prjList = await this.getprjList();
      const prj = prjList.find(item => item.prjId === prjId);
      const prjName = prj?.prjName || "";
      const flowInstanceId = this.routerParams.flowInstanceId || '';
      const qmType = this.routerParams.currentNodeName ? this.routerParams.currentNodeName : '';
      const obj = {
        fileId: row.fileId,
        // fileNames: row.fileName,
        prjId,
        // prjName,
        status: row.status,
        versionIds: row.versionIds || 1,
        fileType: Number(row.fileType),
        source: "ct",
        flowInstanceId,
        qmType
      };
      if (obj.status === 2) {
        obj.status = obj.status.toString();
      }
      // web端用value CAD端用obj
      // 判断是否为cad、revit打开的
      if (!this.showBar || !this.isRVT) {
        console.log('为cad、revit打开的');
        obj.noNeedIssue = "";
        await CefSharp.BindObjectAsync("cefSharpBrower");
        cefSharpBrower.openUrl(JSON.stringify(obj));
      } else {
        console.log("为web打开的");
        noLabelFilePreview(value, prjId, prjName, "ct", "", "", flowInstanceId, qmType);
      }
    },
    downLoadFile(row) {
      const fileId = row.fileId;
      const versionIds = row.versionIds;
      const url = flowFileDownLoad(this.routerParams.flowInstanceId, fileId, versionIds);
      downloadFile(url);
    },

    className(row) {
      return tableRowIcon(row);
    },
    async getprjList() {
      const param = {
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId
      };
      const res = await xtDesign.queryPrj(param);
      const prjList = res.data;
      return prjList;
    },
    // CAD端绑定操作
    async binding(row) {
      this.$emit("binding", row);
    }
  }
};
</script>

<style lang="scss" scoped>
.nameStyle{
  width: 100%;
  display: flex;
  align-items: center;
  .img{
    flex-shrink:0;
    margin:0 5px;
  }
  .fileNameStyle{
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    left:27px
  }
}
.midd-table {
  width: 100%;
  display: flex;
  .el-icon-download {
    margin-right: 15px;
    color: var(--theme-color);
    cursor: pointer;
    font-size: 16px;
  }
  .el-icon-delete {
    color: #f54f45;
    cursor: pointer;
  }
  .el-icon-key,
  .el-icon-unlock {
    cursor: pointer;
    color: var(--theme-color);
    font-size: 16px;
  }
}
.midd-img {
  margin-right: 15px;
  display: block;
  color: var(--theme-color);
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.table_class {
  width: 70px;
  font-size: 14px;
  border-radius: 15px;
  margin: 0 5px;
  text-align: center;
}
.approval_class {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
  text-align: center;
}
.adopt_class {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
  text-align: center;
}
.reject_class {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
  text-align: center;
}
.cancel_class {
  background: #d4d9ec;
  color: #fff;
  text-align: center;
}
</style>
